import { serverAdressesDev } from '@main-shared-lib';

import { FrontendLogger } from '@biz-nest/core-client';
FrontendLogger.configure(undefined, 'debug');


export const environment = {
  production: false
};

export const serverAddresses = {
  ...serverAdressesDev
};

